var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNfcLogoSvgVector(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 2500,
    height: 2500,
    viewBox: "0 0 192.756 192.756",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd",
    clipRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillOpacity: 0,
    d: "M0 0h192.756v192.756H0V0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.27 58.744h25.67v77.01H2.834v42.639h80.927V139.67l24.363 39.156h81.363v-43.072h-25.67v-77.01h26.104V13.93H108.56v40.463L83.326 13.93H3.27v44.814z",
    fill: "#355c90"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M56.004 26.894l10.814 14.404 18.03-5.684-10.779 15.944L85.05 67.291l-18.396-6.62L55.166 75.96l.38-18.686-17.484-6.908 17.346-5.469.596-18.003zM89.506 73.448l10.814 14.406 18.032-5.686-10.784 15.945 10.985 15.731-18.399-6.619-11.487 15.291.381-18.69-17.484-6.906 17.345-5.469.597-18.003zM123.443 120.873l10.813 14.404 18.031-5.685-10.779 15.945 10.98 15.733-18.396-6.622-11.488 15.293.38-18.691-17.482-6.904 17.344-5.471.597-18.002z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNfcLogoSvgVector);
export default __webpack_public_path__ + "static/media/nfc-logo-svg-vector.8b8793dda2bf9064add2e04e849d2927.svg";
export { ForwardRef as ReactComponent };